import project1 from "../../../images/netflix-clone.png";
import project2 from "../../../images/photography-portfolio.png";
import project3 from "../../../images/tomorrows-travels.png";
import project4 from "../../../images/quickeats.png";
import project5 from "../../../images/gym-prototype.png";
import project6 from "../../../images/instaweather.png";

const projects = [
  {
    id: 1,
    project_name: "Netflix Dashboard Clone",
    class: "netflix",
    description:
      "This is a clone of the Netflix dashboard. It is built with React.js and uses TMDB to fetch data for movies and tv shows. It has a hosted backend built in Node and stores user data in a MongoDB database.",
    img: project1,
    url: "https://netflixclone-jg.netlify.app",
    tags: ["React", "Redux", "MongoDB", "Node", "Express", "JSON", "axios"],
  },
  {
    id: 2,
    project_name: "Photography Portfolio",
    class: "photography-portfolio",
    description:
      "This project pushed me to experiment with advanced CSS and TailwindCSS. The main feature of this is the natural flow of the images with a mortar layout. It was built using the MERN stack.",
    img: project2,
    url: "https://neon-kataifi-cfb16b.netlify.app/",
    tags: ["MongoDB", "Express", "React", "Node", "TailwindCSS", "axios"],
  },
  {
    id: 3,
    project_name: "Tomorrows Travels",
    class: "tomtrav",
    description:
      "Tomorrows Travels is a travel advisor that is aimed to help the target user plan out their itinerary for current or upcoming trips. This application was built using the MERN stack.",
    img: project3,
    url: "https://tomorrowstravels.netlify.app/home",
    tags: ["MongoDB", "Express", "React", "Node", "Sass"],
  },
  {
    id: 4,
    project_name: "QuickEats",
    class: "quickeats",
    description:
      "This is a food order/delivery app. It is built with React.js and uses a small database I created to access the menu items the restaurant has to offer. It utilizes Redux for state wide management and also react router for a multi-page design.",
    img: project4,
    url: "https://quickeats.netlify.app/home",
    tags: ["React", "Redux", "Sass", "Firebase"],
  },
  {
    id: 5,
    project_name: "Fitness Landing Page",
    class: "fit-landing-page",
    description:
      "This is a fitness website landing page. The inspiration and design is from webflix on dribbble. The entire layout is built with CSS grid and uses Sass to maintain good architecture and hierarchy.",
    img: project5,
    url: "https://pensive-swanson-24a064.netlify.app/",
    tags: ["JavaScript", "Sass"],
  },
  {
    id: 6,
    project_name: "InstaWeather",
    class: "instaweather",
    description:
      "InstaWeather fetches real-time weather data. It displays the current weather and a 24 hour forecast. It has the option to search for specific cities and see their current weather as well. It was primarily built for mobile, but functions properly on larger devices.",
    img: project6,
    url: "https://elastic-goldstine-0ab1b2.netlify.app/",
    tags: ["JavaScript", "JSON"],
  },
  // {
  //   id: 7,
  //   project_name: "Goal Savings Calculator",
  //   description:
  //     "This application is a calculator that keeps track of your savings goals. It was built using JavaScript and Sass. Once you complete your goal there is a fun little modal that congratulates you on your accomplishment!",
  //   img: project7,
  //   url: "https://savingscountdown.netlify.app/",
  //   tags: ["JavaScript", "Sass"],
  // },
];

export default projects;
